import React from 'react';
import { CircularProgress, Menu, MenuItem } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import './SubTaskMoreDropdown.scss';

export type SubTaskMoreDropdownOption = 'delete';

interface SubTaskMoreDropdownProps {
  anchorEl: Element | null;
  loadingOption?: SubTaskMoreDropdownOption;
  onClickItem: (option: SubTaskMoreDropdownOption) => void;
  onClose: () => void;
}

const options: Record<SubTaskMoreDropdownOption, { actionKey: string; icon: JSX.Element }> = {
  delete: {
    actionKey: 'task.subtasks.deleteSubtask',
    icon: <Delete fontSize="small" />,
  },
};

const SubTaskMoreDropdown: React.FC<SubTaskMoreDropdownProps> = ({
  anchorEl,
  loadingOption,
  onClickItem,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <Menu
      className="subtask-more-dropdown"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      {Object.entries(options).map(([option, { actionKey, icon }]) => (
        <MenuItem
          key={option}
          disabled={!!loadingOption}
          onClick={(e) => {
            e.stopPropagation();
            onClickItem(option as SubTaskMoreDropdownOption);
          }}
          className="subtask-more-dropdown__option"
        >
          {loadingOption === option ? <CircularProgress size={15} /> : icon}
          <p className="subtask-more-dropdown__option__title">{t(actionKey)}</p>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default SubTaskMoreDropdown;
